const history = {
  title: "My Projects",
  upgradeBtn: "Upgrade",
  subTitle: "Don't forget to download your file as it will be deleted after 24 hours.",
  MAgo: "{{num}} minutes ago",
  HAgo: "{{num}} hours ago",
  DAgo: "{{num}} day ago",
  justNow: "Just now",
  originalFile: "Original file",
  selectAllBtn: "Select all",
  emptyTips: "No proiect yet. <1>Go edit</1>",
  deleteTips:"Are you sure you want to delete it?",
};

export default history;
